import React, { Component } from "react";
import styled, { css, withTheme } from "styled-components";
import { transparentize } from "polished";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import MenuIcon from "../../icons/MenuIcon";
import AppProvider from "../App/AppProvider";
import Media from "../../utils/media";
import { inIframe } from "../../utils/embed";

const MenuButton = styled(MenuIcon)`
  padding: 0px 16px;
  min-width: 24px;
  ${props =>
    props.theme.scriptDirection === "rtl"
      ? css`
          padding-right: 18px;
        `
      : css`
          padding-left: 18px;
        `} ${Media.desktop`
    display:none;
  `};
  ${inIframe() &&
    css`
      display: none;
    `};
`;

const StyledAppBar = styled.div`
  font-family: ${props => props.theme.uiFont};
  z-index: 100;
  top: 0px;
  position: fixed;
  width: 100%;
  color: #000000;
  background: ${props => props.theme.background};
  background: linear-gradient(
    ${({ theme }) => `
      180deg,
      ${theme.background} 78%,
      ${transparentize(1, theme.background)} 100%
    `}
  );
  & > div {
    flex: 0 0 100%;
    display: flex;
    flex-direction: ${props =>
      props.theme.scriptDirection === "rtl" ? "row-reverse" : "row"};
    align-items: center;
    align-content: flex-start;
    min-height: 72px;
  }
  a {
    color: ${props => (props.light ? "black" : props.theme.appBarText)};
  }
  ${Media.desktop`
    color: black;
    width: auto;
    min-height: 86px;
    position: relative;

    a {
      color:
      ${props => (props.light ? "black" : props.theme.appBarText)};
      // the props.light is 'undefined'. Manually setting search icon / link color
      color: #111111;
    }
  `};
`;

export const AppBarContentWrapper = styled.div`
  padding: 0 1rem;
`;

class AppBar extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired
  };

  constructor(props) {
    super(props);
    this.appBarRef = React.createRef();
  }

  state = {
    atTop: false
  };

  componentDidMount = () => {
    if (window) window.addEventListener("scroll", this.handleScroll);
  };

  componentWillUnmount() {
    if (window) window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const refRect = this.appBarRef.current.getBoundingClientRect();
    if (refRect.top <= 10) {
      this.setState({ atTop: true });
    } else {
      this.setState({ atTop: false });
    }
  };

  render() {
    // props.showMenuButton doesn't have any effect??
    return (
      <StyledAppBar atTop={this.state.atTop}>
        <div ref={this.appBarRef}>
          {this.props.showMenuButton && (
            <AppProvider.Consumer>
              {({ toggleDrawer }) => (
                <MenuButton
                  id="side-menu-button"
                  onClick={toggleDrawer}
                  size={24}
                  color={this.props.theme.appBarText}
                />
              )}
            </AppProvider.Consumer>
          )}
          {/* <DrawerMenu /> */}
          {this.props.children}
        </div>
      </StyledAppBar>
    );
  }
}

export default withRouter(withTheme(AppBar));
